export const gbp = (n) => "£" + Number(n || 0).toFixed(2);

export const INVOICE_STATUSES = ["draft", "sent", "part-paid", "paid", "overdue"];

export const INVOICE_STATUS_COLORS = {
  draft: "bg-slate-200 text-slate-600",
  sent: "bg-blue-100 text-blue-700",
  "part-paid": "bg-amber-100 text-amber-700",
  paid: "bg-emerald-100 text-emerald-700",
  overdue: "bg-red-100 text-red-700",
};

export const statusLabel = (s) => (s === "part-paid" ? "Part-paid" : s.charAt(0).toUpperCase() + s.slice(1));
